/**
 * @todo return strings only.
 *
 * @template T
 * @param {T} value
 * @param {number} fractionDigits
 * @returns {string|T}
 */
export function toFixedWhenFloat(value, fractionDigits = 1) {
    return String(parseFloat(value)).includes('.') ?
        parseFloat(value).toFixed(fractionDigits) : value;
}

/**
 * @param value
 * @returns {string}
 */
export function toDivide(value) {
    var int = String(Math.trunc(value));
    if ('NaN' === int) return '';
    if (int.length <= 3) return int;
    var space = 0;
    var number = '';

    for (var i = int.length - 1; i >= 0; i--) {
        if (space === 3) {
            number = ' ' + number;
            space = 0;
        }

        number = int.charAt(i) + number;
        space++;
    }

    return number;
}

export function moneyFormat(price) {
    return new Intl.NumberFormat('ru-RU').format(price);
}

/**
 * @param {string|number} value
 * @return {string}
 */
export function leadZero(value) {
    value = numeric(parseInt(value));

    return String(Math.abs(value)).length < 2 ? '0' + value : String(value);
}

/**
 * @param {string|number} value
 * @return {string}
 */
export function increaseInteger(value) {
    return String(toInt(value) + 1);
}

/**
 * @param {string|number} value
 * @param {number} min
 * @return {string}
 */
export function decreaseInteger(value, min = 0) {
    return String(Math.max(min, toInt(value) - 1));
}

/**
 * @param {string|number} value
 * @return {string}
 */
export function increaseFloat(value) {
    const increased = toFloat(value) + 0.1;
    return increased.toFixed(1);
}

/**
 * @param {string|number} value
 * @param {number} min
 * @return {string}
 */
export function decreaseFloat(value, min = 0) {
    const decreased = Math.max(min, toFloat(value) - 0.1);
    return decreased.toFixed(1);
}

export function toFloat(value) {
    return numeric(parseFloat(value));
}

export function toInt(value) {
    return numeric(parseFloat(value));
}

function numeric(value) {
    return isFinite(value) ? value : 0;
}
